import axios from "axios";
import React, { useEffect, useState } from "react";
import Baseurl from "../BaseURL/Baseurl";

const DriverSec1 = () => {
  const [data, setdata] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response2 = await axios.get(`${Baseurl.baseurl}get-data/`);
        console.log(response2.data, "response2");
        setdata(response2?.data);
      } catch (err) {
        console.log(err);
      }
    };

    console.log(data, "datauk");


    fetchData();
  }, []);


  return (
    <>
      <section className="about-area pt-100 pb-60">
        <div className="container">
          <div className="row gx-xl-5 align-items-center">
            <div
              className="col-lg-6"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="image mb-40">
                <img
                  className="lazyload"
                  src="/assets/images/about.png"
                  alt="driver info"
                />
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up">
              <div className="content-title mb-40">
                <span className="subtitle mb-10 color-primary">Series Key</span>
                <h2 className="title mb-25">
                  Active Driver Listing
                  <span>.</span>
                </h2>
                <div
                  className="text"
                  style={{ maxHeight: "500px", overflowY: "auto" }}
                >
                  {data?.map((item, index) => (
                    <div key={index}>
                      <p>{item?.SERIES}</p>
                      <p style={{ fontWeight: "bold" }}>{item?.SERIESKEY}</p>
                    </div>
                  ))}
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DriverSec1;
